/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Vendor headcount/flow point. `month` is the vendor's raw label.
 */
export interface CompanyMonthlyCountSchema {
  month: string;
  count?: number | null;
}
